import product1 from "../assets/img-01.jpg";
import product2 from "../assets/img-02.jpg";
import product3 from "../assets/img-03.jpg";
import product4 from "../assets/img-04.jpg";
import product5 from "../assets/img-05.jpg";
import product6 from "../assets/img-06.jpg";

const ProductsCardData = [
  {
    imgsrc: product1,
    title: "Sofa",
  },
  {
    imgsrc: product2,
    title: "Stool 067",
  },

  {
    imgsrc: product3,
    title: "Dining table 23",
  },
  {
    imgsrc: product4,
    title: "Chair 023",
  },
  {
    imgsrc: product5,
    title: "Sofa 57",
  },
  {
    imgsrc: product6,
    title: "Stool 28",
  },
];

export default ProductsCardData;